import {DocumentReportIcon, DocumentSearchIcon, PlusIcon, UserGroupIcon, UserIcon} from '@heroicons/react/outline'
import {useTranslation} from "react-i18next";

export default function FeatureSection() {
    const {t} = useTranslation();

    const benefitsArr = [
        {
            name: t('home.benefits.list.doctor.name'),
            points: t('home.benefits.list.doctor.points').split(','),
            icon: UserIcon
        },
        {
            name: t('home.benefits.list.pharmacy.name'),
            points: t('home.benefits.list.pharmacy.points').split(','),
            icon: PlusIcon
        },
        {
            name: t('home.benefits.list.patients.name'),
            points: t('home.benefits.list.patients.points').split(','),
            icon: UserGroupIcon
        },
        {
            name: t('home.benefits.list.medical-analysis.name'),
            points: t('home.benefits.list.medical-analysis.points').split(','),
            icon: DocumentReportIcon
        },
        {
            name: t('home.benefits.list.research-labs.name'),
            points: t('home.benefits.list.research-labs.points').split(','),
            icon: DocumentSearchIcon
        },
    ]

    return (
        <div className="relative bg-white" id="features">
            <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
                <h2 className="text-base font-semibold tracking-wider text-indigo-600 uppercase">{t('home.benefits.name')}</h2>
                <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
                    {t('home.benefits.title')}
                </p>
                <p className="mt-5 max-w-prose mx-auto text-xl text-gray-500">
                    {t('home.benefits.description')}
                </p>
                <div className="mt-12">
                    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                        {benefitsArr.map((feature) => (
                            <div key={feature.name} className="pt-6">
                                <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                                    <div className="-mt-6">
                                        <div>
                      <span className="inline-flex items-center justify-center p-3 bg-indigo-500 rounded-md shadow-lg">
                        <feature.icon className="h-6 w-6 text-white" aria-hidden="true"/>
                      </span>
                                        </div>
                                        <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">{feature.name}</h3>
                                        <div className="mt-5 text-base text-gray-500">
                                            {feature.points.map((point) => (
                                                <div key={point} className="relative">
                                                    <dd className="mt-2 ml-9 text-base text-left text-gray-500">{point}</dd>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
